import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { profileStart } from "../../store/actions/UserAction";
import PageLoader from "../helper/PageLoader";
import SomethingWentWrong from "../Common/SomethingWentWrong";
import HeaderIndex from "./Header/HeaderIndex";
import { useNavigate } from "react-router-dom";
import SideBar from "./SideBar";
import "../layouts/Layout.css";
import MobileNav from "./MobileNav";
import { staticEmailListStart } from "../../store/actions/BankAccountAction";

const NewLayout = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isMobile = useSelector((state) => state.user.isMobile);
  const [isLoggedIn, setIsLoggedIn] = useState(
    localStorage.getItem("token") || sessionStorage.getItem("token")
      ? true
      : false
  );
  const profile = useSelector((state) => state.user.profile);
  const logout = useSelector((state) => state.user.logout);
  const [skipRender, setSkipRender] = useState(true);

  useEffect(() => {
    if (isLoggedIn && !Object.keys(profile.data).length > 0) {
      dispatch(profileStart());
      dispatch(staticEmailListStart());
    }
  }, []);

  useEffect(() => {
    if (!skipRender && !logout.loading && Object.keys(logout.data).length > 0) {
      localStorage.clear();
      sessionStorage.clear();
      localStorage.setItem("lang", "en");
      navigate("/login");
    }
    setSkipRender(false);
  }, [logout]);

  return (
    <>
      {/* {profile.buttonDisable ? <PageLoader /> : (Object.keys(profile.data).length > 0 || !isLoggedIn) ? */}
      <>
        <HeaderIndex />
        <div className="new-main-wrapper">
          {!isMobile && <SideBar />}
          {isMobile && <MobileNav />}
          {props.children}
        </div>
        {/* <NewFooterIndex /> */}
      </>
      {/* : <SomethingWentWrong />
      } */}
    </>
  );
};

export default NewLayout;
